import React from 'react'
import * as R from 'ramda'

import QualityScore from './QualityScore'
import {
  Wrapper,
  StarRatingWrapper,
  Stars,
  Star,
  Reviews,
  Label,
} from './styles'
import { starRatingText } from './utils'

const baseRatings = [0, 1, 2, 3, 4]

const Rating = ({
  className,
  rating,
  label,
  reviewCount,
  qualityCategoryScore,
  fullRatingsDisplayBool = false,
  CMSTooltipsBool,
}) => (
  <Wrapper className={className} reviewCount={reviewCount}>
    <StarRatingWrapper>
      {reviewCount > 0 && (
        <React.Fragment>
          <Stars>
            {baseRatings.map(r => (
              <Star key={r} isActive={r < rating} />
            ))}
          </Stars>
          {!R.isNil(reviewCount) && (
            <Reviews>
              {starRatingText(reviewCount, fullRatingsDisplayBool)}
            </Reviews>
          )}
        </React.Fragment>
      )}
    </StarRatingWrapper>
    {qualityCategoryScore && (
      <QualityScore
        qualityCategoryScore={qualityCategoryScore}
        fullRatingsDisplayBool={fullRatingsDisplayBool}
        CMSTooltipsBool={CMSTooltipsBool}
        reviewCount={reviewCount}
      />
    )}
    {label && <Label>{label}</Label>}
  </Wrapper>
)

export default Rating
